import {Pipe, PipeTransform} from '@angular/core';
import {TemperatureUnit} from '../enums/temperature-unit.enum';
import {AirComponentType} from '../../afb-api/enums/air-component-type.enum';

@Pipe({
  name: 'sensorUnit'
})

export class SensorUnitPipe implements PipeTransform {
  transform(sensorKey: AirComponentType, tempUnit?: TemperatureUnit): string {
    const sensorUnitPair = {
      [AirComponentType.Score]: '/100',
      [AirComponentType.Temperature]: tempUnit === TemperatureUnit.Fahrenheit ? '°F' : '°C',
      [AirComponentType.Humidity]: '%',
      [AirComponentType.CO2]: 'ppm',
      [AirComponentType.Chemicals]: 'ppb',
      [AirComponentType.Dust]: 'µg/m³',
      [AirComponentType.PM25]: 'µg/m³'
    };

    return sensorUnitPair[sensorKey] != null ? sensorUnitPair[sensorKey] : null;
  }
}
